import axios from "axios";
import router from "@/router/index";
import store from "./../store/index";

const CancelToken = axios.CancelToken;
export let source = CancelToken.source();

export const cancelRequest = async () => {
  source.cancel("cancel forzado");
  source = CancelToken.source();
}

 let Api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  "Access-Control-Allow-Private-Network": true
});

Api.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("access_token");

    if (token) {
      config.headers["Authorization"] = token;
    }
    if(source){
      config.cancelToken = source.token
    }
    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);

Api.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    let newError = {...error}
    if(newError.message == 'cancel forzado'){
      newError = {...newError, response:{status: 401}}
    }
    if(newError.status){
      if (newError.response.status === 401) {
        store.dispatch("authentication/logoutAux", null, { root: true });
        // return null
      }
      // return Promise.reject(newError);
    }
    return Promise.reject(newError);
  }
);


export default Api